import React, { useEffect } from "react";
import { Card, Col, Row, Table } from "react-bootstrap";

import { useTranslation } from "react-i18next";

function HourSalesCard({ data }) {
  const {
    t,
  } = useTranslation();

  return (
    <Card className="strpied-tabled-with-hover">
      <Card.Header>
        <Row>
          <Col>
            <Card.Title as="h4">{`${data.name}`}</Card.Title>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="table-responsive p-0">
        <Table className="table-hover" style={{ tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th>{t("tables.headers.hour")}</th>
              <th className="align-text-right">{t("tables.headers.docs")}</th>
              <th className="align-text-right">{t("tables.headers.totalEuro")}</th>
              <th className="align-text-right">{t("tables.headers.percentagePercent")}</th>
            </tr>
          </thead>
          <tbody>
            {data.hours.map((row) => (
              <tr key={row.hour}>
                <td>{`${row.hour.toString().padStart(2, "0")} - ${(row.hour + 1).toString().padStart(2, "0")}`}</td>
                <td className="align-text-right">{row.orders}</td>
                <td className="align-text-right">{row.total.toFixed(2)}</td>
                <td className="align-text-right">{row.percentage.toFixed(0)}</td>
              </tr>
            ))}
            <tr>
              <td className="bold">{t("tables.headers.total")}</td>
              <td className="bold align-text-right">{data.orders}</td>
              <td className="bold align-text-right">{data.total.toFixed(2)}</td>
              <td></td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default HourSalesCard;
